import _ from 'lodash';
import { Location } from 'react-router';

/**
 * 브라우저 뒤로가기 기록을 저장하는 스토어
 */
class HistoryStore {
    private readonly histories: Location[] = [];

    constructor() {}

    push(location: Location) {
        const lastLocation = this.histories[this.histories.length - 1];
        if (_.isEqual(lastLocation, location)) {
            return;
        }

        this.histories.push(location);
    }

    pop() {
        this.histories.pop();
    }

    hasHistory() {
        return this.histories.length > 1;
    }
}

export default new HistoryStore();
